/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field-appearance-legacy[_ngcontent-%COMP%]   label.mat-form-field-label[_ngcontent-%COMP%],   .mat-form-field-label{color:#696969!important}  .mat-form-field.mat-focused .mat-form-field-label{color:#000!important}  .mat-form-field-infix ::-webkit-input-placeholder{color:#696969}  .mat-form-field-infix :-ms-input-placeholder{color:#696969}  .mat-form-field-infix ::-ms-input-placeholder{color:#696969}  .mat-form-field-infix ::placeholder{color:#696969}"];
export { styles as styles };
